@if(callPassword()) {
  <div class="newtel">
    <h3 class="newtel--header">{{ "auth.confirmation.enterByPhone" | translate }}</h3>
    <div class="newtel--description">
      {{ "auth.confirmation.newtel__description" | translate : {phone: tel()} }}
    </div>
    <a class="newtel--confirmation_number" [href]="'tel:+' + callPassword()?.confirmation_number">{{ callPassword()?.confirmation_number }}</a>
    <div class="newtel__qr--container">
      <div class="newtel__qr--description">
        {{ "auth.confirmation.newtel__description__qr" | translate : {phone: callPassword()?.confirmation_number} }}
      </div>
      <div class="newtel__qr--wrapper">
        <span class="newtel__qr--corner newtel__qr--corner-top-left"></span>
        <span class="newtel__qr--corner newtel__qr--corner-top-right"></span>
        <span class="newtel__qr--corner newtel__qr--corner-bottom-left"></span>
        <span class="newtel__qr--corner newtel__qr--corner-bottom-right"></span>
        <img alt [src]="callPassword()?.qr_code_uri" class="newtel__qr"/>
      </div>
    </div>
  </div>
}
